export class PbdcRegulamentos {

    // LOCAL DOS ARQUIVOS - VM43 /var/www/html/wp-content/uploads/2023/09/
    static pbdcRegulamentosLista: PbdcRegulamentos[] = [
        { tipo: 'docLink', descricao: 'Quadro comparativo – PBDC', caminho: 'https://www.centrus.org.br/wp-content/uploads/2024/05/Quadro_comparativo_PBDC_30_05.pdf' },
        { tipo: 'docLink', descricao: 'Regulamento do PBDC ', caminho: 'https://www.centrus.org.br/wp-content/uploads/2023/09/Regulamento_PBDC_10072024_com_capa.pdf' },
        { tipo: 'docLink', descricao: '18/09/2023 a 09/07/2024', caminho: 'https://www.centrus.org.br/wp-content/uploads/2023/09/07_regulamento_pbdc_18092023_ate_hoje.pdf' },
        { tipo: 'docLink', descricao: '14/04/2022 a 17/09/2023', caminho: 'https://www.centrus.org.br/wp-content/uploads/2020/08/06-regulamento_pbdc_14042022_ate_hoje.pdf' },
        { tipo: 'docLink', descricao: '03/04/2017 a 13/04/2022', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/05-reg_pbdc_03042017_a_26082022.pdf' },
        { tipo: 'docLink', descricao: '07/07/2014 a 02/04/2017', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/04-reg_pbdc_07072014_a_02042017.pdf' },
        { tipo: 'docLink', descricao: '18/01/2013 a 06/07/2014', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/03-reg_pbdc_18012013_a_06072014.pdf' },
        { tipo: 'docLink', descricao: '07/12/2011 a 17/01/2013', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/02-reg_pbdc_07122011_a_17012013.pdf' },
        { tipo: 'docLink', descricao: '13/04/2011 a 06/12/2011', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/01-reg_pbdc_13042011_a_06122011.pdf' }

    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {
    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/pbdc-regulamentos.ts